export default [
  {
    path: '/user/profile',
    name: 'UserProfile',
    component: () => import('./views/UserView.vue'),
    meta: {
      requiresAuth: true,
      title: 'profile'
    }
  }
]